import request from '@/utils/request'

let FangjianApi = {

  /*房间管理列表*/
  list(data) {
    return request._post('/shop/plus.fangjian.Index/index', data);
},
/*添加房间管理*/
add(data) {
    return request._post('/shop/plus.fangjian.Index/add', data);
},
/*修改房间管理*/
edit(data) {
    return request._post('/shop/plus.fangjian.Index/edit', data);
},
/*删除房间管理*/
del(data) {
    return request._post('/shop/plus.fangjian.Index/del', data);
},
/*房间管理详情*/
detail(data) {
  return request._post('/shop/plus.fangjian.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.fangjian.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.fangjian.Setting/getSetting', data, errorback);
    },
}
export default FangjianApi;



// WEBPACK FOOTER //
// ./src/api/fangjian.js